<mat-dialog-content>
    <div class="dialog-title">Edit Columns</div>
    <div class="dialog-description">
        Drag and drop to edit and rearrange column titles
    </div>
    <div class="columns-container-area">
        <div class="columns-container">
            <div class="columns-header">Columns</div>
            <div
                    cdkDropList
                    #columnsList="cdkDropList"
                    [cdkDropListData]="nonSelectedColumns"
                    [cdkDropListConnectedTo]="[selectedColumnsList]"
                    class="columns-list"
                    (cdkDropListDropped)="drop($event)">
                <div class="column-box" *ngFor="let item of nonSelectedColumns" cdkDrag>{{item.fieldName}}</div>
            </div>
        </div>

        <div class="columns-container">
            <div class="columns-header">Selected Columns</div>
            <div
                    cdkDropList
                    #selectedColumnsList="cdkDropList"
                    [cdkDropListData]="selectedColumns"
                    [cdkDropListConnectedTo]="[columnsList]"
                    class="columns-list"
                    (cdkDropListDropped)="drop($event)">
                <div class="column-box" *ngFor="let item of selectedColumns" cdkDrag>{{item.fieldName}}</div>
            </div>
        </div>   
    </div>

    
</mat-dialog-content>
<mat-dialog-actions class="action-buttons-container">
    <button mat-button mat-dialog-close mat-stroked-button>Cancel</button>
    <button mat-button cdkFocusInitial (click)="applyChanges()" mat-stroked-button>
        Save
    </button>
</mat-dialog-actions>